// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export default {
    "dirty": false,
    "raw": "1947916",
    "hash": "1947916",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "1947916",
    "semverString": null
};
/* tslint:enable */
